<template>
  <div class="wrapper-detail">
    <div class="wrapper-item">
      <div class="para-title">订单信息</div>

      <!-- 订单信息 -->
      <OrderInfo :detailInfo="detail" @updateDetail="getDetail" />

      <!-- 账单信息 -->
      <template v-if="!!detail.store">
        <PeriodStoreInfo v-if="detail.orderBillList" :detailInfo="detail" />
      </template>
      <template v-else>
        <PeriodMallInfo ref="period" :orderBillList="detail.orderBillList" />
      </template>

      <!-- 收货信息 -->
      <AddressInfo
          :flag.sync="flag"
          :orderAddress="detail.orderAddress"
          :status="detail.status"
          @updateDetail="getDetail"
      />

      <!-- 发货信息 -->
      <template v-if="!!detail.orderDelivery">
        <DeliveryInfo :orderDelivery="detail.orderDelivery" :detail="detail" />
      </template>
    </div>

    <!-- 门店信息 -->
    <div class="wrapper-item mt20">
      <div class="para-title">门店信息</div>

      <template v-if="!!detail.store">
        <StoreInfo
          :detailInfo="detail"
          :flag.sync="flag"
          @updateDetail="getDetail"
        />
      </template>
    </div>

    <div class="wrapper-item mt20">
      <div class="para-title">其他</div>

      <!-- 联系人 -->
      <ContactInfo
          :type="1"
          :member="detail.member"
          :orderInfo="detail"
          :flag.sync="flag"
          @updateDetail="getDetail"
      />

      <!-- 订单备注 -->
      <ContactInfo
          :type="2"
          :flag.sync="flag"
          :member="detail.member"
          :orderInfo="detail"
          @updateDetail="getDetail"
          style="margin-top: 10px;"
      />
    </div>
  </div>
</template>

<script>
import OrderInfo from "./modules/order-info.vue";
import StoreInfo from "./modules/store-info.vue";
import ContactInfo from "./modules/contact-info.vue";
import AddressInfo from "./modules/address-info.vue";
import DeliveryInfo from "./modules/delivery-info.vue";
import PeriodStoreInfo from "./modules/period-store-info.vue";
import PeriodMallInfo from "./modules/period-mall-info.vue";

export default {
  name: "DetailBase",

  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    OrderInfo,
    StoreInfo,
    ContactInfo,
    AddressInfo,
    DeliveryInfo,
    PeriodStoreInfo,
    PeriodMallInfo,
  },

  data() {
    return {
      flag: true,
    };
  },

  computed: {
    finalLevel() {
      return this.detail.orderScoreProfile
        ? this.detail.orderScoreProfile.finalHitGrade
        : "";
    },
    sysScore() {
      return this.detail.orderScoreProfile
        ? this.detail.orderScoreProfile.sysHitScore
        : "";
    },
    sysLevel() {
      return this.detail.orderScoreProfile
        ? this.detail.orderScoreProfile.sysHitGrade
        : "";
    },
    scoreProfileData() {
      return this.detail.orderScoreProfile || {};
    },
  },

  methods: {
    goJiShen() {
      this.$emit("goJS");
    },

    getDetail() {
      this.$emit("refresh");
    },

    closePage() {
      this.emitAwindow();
      window.close();
    },

    emitAwindow() {
      if (window.opener) {
        if (window.opener.getBpageList) {
          window.opener.getBpageList();
        } else {
          window.opener.frames[0].getBpageList();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-detail {
  width: 100%;
  margin-top: 0;

  .wrapper-item {
    background-color: #ffffff;
    border: none;
    width: 100%;
    border-radius: 12px;
    color: #222222;
    padding: 0;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    .para-title {
      font-size: 18px;
      font-weight: 600;
      padding: 20px 24px;
      margin: 0;
      border-bottom: 2px solid #f0f2f5;
      background: linear-gradient(135deg, #fafbfc 0%, #ffffff 100%);
      color: #303133;
      display: flex;
      align-items: center;
      gap: 8px;
      
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 18px;
        background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
        border-radius: 2px;
      }
    }
  }
}

.without-layout .wrapper-detail {
  padding: 0 !important;
}
</style>
